import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Card, CardTitle, CardBody } from "react-bootstrap";
import "../../assets/css/Secretsanta.css";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Toast } from "primereact/toast";
import GifLoder from '../../components/GifLoder';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { getSocket } from '../../context/socket'; // adjust path as needed
import WishAdd from "./WishAdd";
import Giftlist from "./Giftlist";
const UserSecretSanta = () => {
    const { accessToken, userId, role, username } = useAuth();
    const socket = getSocket();
    const [visibleRight, setVisibleRight] = useState(false);
    const [visibleRight2, setVisibleRight2] = useState(false);
    const [showInitialCard, setShowInitialCard] = useState(true);
    const [showSecondCard, setShowSecondCard] = useState(false);
    const [showThirdCard, setShowThirdCard] = useState(false);

    const [eventId, setEventId] = useState(null);
    const [eventStatus, setEventStatus] = useState(null);
    const [progressStatus, setProgressStatus] = useState(null);
    const [receiverInfo, setReceiverInfo] = useState(null);
    const [loading, setLoading] = useState(false);



    const toast = useRef(null);

    /*---------------------gift list selection -----------------------*/




    const fetchEventStatus = () => {
        setLoading(true); // ⏳ start

        socket.emit("fetchEventStatus");

        socket.once("eventStatus", (data) => {
            setEventStatus(data.status);

            if (data.status === "active") {
                setEventId(data.event_id);
            }

            setLoading(false); // ✅ end
        });
    };


    const fetchSantaProgress = () => {
        if (!eventId) return;

        setLoading(true); // ⏳ start

        socket.emit("fetchSantaProgress", {
            user_id: userId,
            event_id: eventId
        });

        socket.once("santaProgress", (data) => {
            setProgressStatus(data.status);

            if (data.status === "registration_ongoing") {
                setShowInitialCard(true);
                setShowSecondCard(false);
                setShowThirdCard(false);
            }

            else if (data.status === "draw_incomplete") {
                setShowInitialCard(false);
                setShowSecondCard(true);
                setShowThirdCard(false);
            }

            else if (data.status === "draw_complete") {
                setShowInitialCard(false);
                setShowSecondCard(false);
                setShowThirdCard(true);
                setReceiverInfo(data.draw);

            }

            setLoading(false); // ✅ end
        });
    };


    useEffect(() => {
        if (!socket) return;

        // --- Fetch event status when screen loads ---
        fetchEventStatus();

        // 🔁 Re-fetch on backend update
        socket.on("santaUpdated", () => {
            console.log("Santa Updated received — refetching...");
            fetchSantaProgress();
        });

        return () => {
            socket.off("santaUpdated");
            socket.off("eventStatus");
            socket.off("santaProgress");
        };
    }, [socket]);


    useEffect(() => {
        if (!socket) return;

        fetchSantaProgress(); // initial load

        socket.on("santaUpdated", () => {
            fetchSantaProgress();
        });

        return () => {
            socket.off("santaUpdated");
        };
    }, [eventId, socket]);



    if (loading) {
        return (
            <div className="loderDiv">
                <GifLoder />
            </div>
        );
    }
    return (
        <>
            <Toast ref={toast}></Toast>

            {/* FIRST CARD */}
            {showInitialCard && (
                <Row className="body_content santabg align-items-end">
                    <Col lg={3} className="fade-in position-relative" style={{bottom:'24%'}}>
                        <Card className="shadow p-3 text-center">
                            <CardTitle>Hi! <em >{username}</em></CardTitle>
                            <CardBody className="pb-0 pt-1">
                               <p className="mb-0"><small className="text-muted">Let's make this festive season unforgettable!</small></p>
                            </CardBody>
                            <Button
                                label="Make A Wish"
                                icon="pi pi-gift"
                                severity="danger"
                                className="py-2 d-block mt-4"
                                onClick={() => setVisibleRight(true)}
                            />
                        </Card>
                    </Col>
                    <video autoPlay loop muted playsInline className="bg_video">
                        <source src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/christmas%20loop%202_secret%20santa.mp4" type="video/mp4" />
                    </video>
                </Row>
            )}

            {/* SECOND CARD */}
            {showSecondCard && (
                <Row className="body_content secondSantabg">
                    <Col lg={12} className="text-end fade-in">
                        {/* {eventStatus === true && (
                            <Button
                                label="You are the Secret Santa of! Click to proceed."
                                severity="help"
                                icon="pi pi-eye"
                                className="py-2 mt-4 "
                                style={{ width: "fit-content" }}
                                onClick={() => {
                                    setShowSecondCard(false);
                                    setShowInitialCard(false);
                                }}
                            />
                        )} */}
                    </Col>
                </Row>
            )}

            {/* PROFILE CARD */}
            {showThirdCard && (
                <Row className="body_content overflow-hidden">
                    <Col lg={12} className="fade-up p-0">
                        <aside className="profile-card shadow">
                            <header>
                                <img
                                    src={
                                        receiverInfo?.receiverUser?.profileImage?.image_url
                                            ? receiverInfo.receiverUser.profileImage?.image_url
                                            : "https://demoadmin.thegraphe.com/admin/static/media/no_user.6f678b05521261910525.png"
                                    }
                                    alt="Avatar"
                                    className="hoverZoomLink"
                                />
                                <h1><em>{receiverInfo?.receiverUser
                                    ? `${receiverInfo.receiverUser.first_name} ${receiverInfo.receiverUser.last_name}`
                                    : "Waiting..."}</em></h1>
                                <h2>Your Secret Santa Receiver</h2>

                                {/* ✅ Hide button if BOTH gift details exist */}
                                {!receiverInfo?.image_url || !receiverInfo?.amazon_url ? (
                                    <Button
                                        label="Select Gift"
                                        icon="pi pi-gift"
                                        severity="help"
                                        className="py-2 d-block mt-4 w-100"
                                        onClick={() => setVisibleRight2(true)}
                                    />
                                ) : null}
                                <div className="gftText">
                                    {receiverInfo?.image_url && (
                                        <img src={receiverInfo?.image_url} alt="giftimage" />
                                    )}
                                    <div className="url-wrapper">
                                        {receiverInfo?.amazon_url ? (
                                            <a
                                                href={receiverInfo.amazon_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="two-line-ellipsis m-0 text-info"
                                            >
                                                {receiverInfo.amazon_url}
                                            </a>
                                        ) : (
                                            <span>No gift added yet</span>
                                        )}
                                    </div>
                                </div>
                            </header>
                        </aside>
                    </Col>

                    <video autoPlay muted loop playsInline className="bg_video">
                        <source src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/Christmas%201%20loop.mp4" type="video/mp4" />
                    </video>
                </Row>
            )}

            {/* IMAGE UPLOAD SIDEBAR */}
            <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
                dismissable={false}
                style={{ width: "450px" }}
            >
                <WishAdd onClose={() => setVisibleRight(false)} eventID={eventId} />

            </Sidebar>

            {/* GIFT SELECTION SIDEBAR */}
            <Sidebar
                visible={visibleRight2}
                position="right"
                onHide={() => setVisibleRight2(false)}
                dismissable={false}
                style={{ width: "450px" }}
                className="giftslid"
            >
                <Giftlist onClose={() => setVisibleRight2(false)} eventID={eventId} />
            </Sidebar>
        </>
    );
};

export default UserSecretSanta;